import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  HAZMAT_FEE,
  PERCENT_INSURED,
  PREFERRED_REPAIR_STATION_ID
} from "MODULES/PurchaseOrders/constants";
import { BUYER_CREDIT_PCT, MARKUP, QUANTITY } from "APP_ROOT/constants";
import {
  CONDITION,
  INSPECTED,
  LEAD_TIME,
  OVERHAULED,
  PART_ID,
  REPAIRED,
  TAG_DATE,
  TAGGED_BY
} from "MODULES/inventories/constants";
import { DOM } from "MODULES/parts/constants";

export default function validate(values, props) {
  return validator(values, form => {
    form
      .validate(PART_ID, CONDITION, MARKUP, QUANTITY, BUYER_CREDIT_PCT)
      .satisfies(rules.required);

    form.validate(LEAD_TIME).satisfies(rules.requiredAllowZero);
    form.validate(QUANTITY).satisfies(rules.isGreaterThan(0));
    form.validate(MARKUP, PERCENT_INSURED).satisfies(rules.isBetween(1, 100));

    if (
      (props && props.domLifeYears && props.llp) ||
      (props.selectedPart && props.selectedPart.dom_sensitive)
    ) {
      form.validate(DOM).satisfies(rules.required);
    }

    if (props.selectedPart && props.selectedPart.hazmat) {
      form
        .validate(HAZMAT_FEE)
        .satisfies(rules.required, rules.isGreaterThanOrEqualTo(0));
    }

    form.validate(PREFERRED_REPAIR_STATION_ID).satisfies(rules.required);

    if ([OVERHAULED, INSPECTED, REPAIRED].includes(values.condition)) {
      form.validate(TAG_DATE).satisfies(rules.required);
      form.validate(TAGGED_BY).satisfies(rules.required);
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/LineItemsTable/validate.js